import { Checkbox, Form, FormInstance, Select, Switch } from "antd";
import { ReactNode } from "react";
import SelectDropdownLgIcon from "../../../../../assets/icons/SelectDropdownLgIcon";
import { selectStringOption } from "../../../../../utils/utils";

type Props = {
  name: string;
  index: number;
  form: FormInstance<any>;
};

export default function FileUploadField({ name, index, form }: Props) {
  const isAllow = Form.useWatch(
    [name, index, "allow_only_specific_file_type"],
    form
  );

  return (
    <div className="mt-4 max-w-[450px]">
      <FileItem title="Allow only specific file types">
        <Form.Item
          name={[index, "allow_only_specific_file_type"]}
          valuePropName="checked"
          className="mb-0"
          initialValue={false}
        >
          <Switch />
        </Form.Item>
      </FileItem>
a
      {isAllow && (
        <Form.Item
          name={[index, "allow_only_specific_file_type_checkbox"]}
          className="mb-2 mt-2"
        >
          <Checkbox.Group className="!grid !grid-cols-2 gap-3">
            {fileTypeList.map((type) => (
              <Checkbox
                key={type.value}
                value={type.value}
                className="text-sm !text-display-body"
              >
                {type.label}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </Form.Item>
      )}

      <FileItem title="Maximum number of files" className="pt-2">
        <Form.Item
          name={[index, "maximum_num_of_files"]}
          className="mb-0"
          initialValue={1}
        >
          <Select
            showSearch
            optionFilterProp="children"
            suffixIcon={<SelectDropdownLgIcon />}
            size="middle"
            style={{ width: 80 }}
            options={selectStringOption(
              [...Array(5)].map((_, i) => (i + 1).toString()),
              "number"
            )}
            className="select-border-none"
          />
        </Form.Item>
      </FileItem>
      <FileItem title="Maximum file size" className="pt-4">
        <Form.Item
          name={[index, "maximum_file_size_mb"]}
          className="mb-0"
          initialValue={5}
        >
          <Select
            showSearch
            optionFilterProp="children"
            suffixIcon={<SelectDropdownLgIcon />}
            size="middle"
            style={{ width: 110 }}
            options={mbList}
            className="select-border-none"
          />
        </Form.Item>
      </FileItem>
    </div>
  );
}

type FileItemProps = {
  title: string;
  children: ReactNode;
  className?: string;
};
const FileItem = ({ title, className, children }: FileItemProps) => (
  <div
    className={`flex items-center justify-between flex-wrap gap-2 ${className}`}
  >
    <div className="text-display-body text-sm font-medium">{title}</div>

    {children}
  </div>
);

const mbList = [
  {
    label: "5 MB",
    value: 5,
  },
  {
    label: "10 MB",
    value: 10,
  },
  {
    label: "25 MB",
    value: 25,
  },
  {
    label: "50 MB",
    value: 50,
  },
  {
    label: "100 MB",
    value: 100,
  },
  {
    label: "500 MB",
    value: 500,
  },
  {
    label: "1000 MB",
    value: 1000,
  },
];

const fileTypeList = [
  {
    label: "Document",
    value: "document",
  },
  {
    label: "Presentation",
    value: "presentation",
  },
  {
    label: "Spreadsheet",
    value: "spreadsheet",
  },
  {
    label: "Drawing",
    value: "drawing",
  },
  {
    label: "PDF",
    value: "pdf",
  },
  {
    label: "Image",
    value: "image",
  },
  {
    label: "Video",
    value: "video",
  },
  {
    label: "Audio",
    value: "audio",
  },
];
